import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_d134e8ca from 'nuxt_plugin_plugin_d134e8ca' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_nuxtenv_1f52afec from 'nuxt_plugin_nuxtenv_1f52afec' // Source: ./nuxt-env.js (mode: 'all')
import nuxt_plugin_portalvue_5165652a from 'nuxt_plugin_portalvue_5165652a' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_pluginrouting_1e5b0d5d from 'nuxt_plugin_pluginrouting_1e5b0d5d' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_5a472332 from 'nuxt_plugin_pluginmain_5a472332' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_veevalidate_0228353c from 'nuxt_plugin_veevalidate_0228353c' // Source: ./vee-validate.js (mode: 'all')
import nuxt_plugin_apollomodule_3de1e0d6 from 'nuxt_plugin_apollomodule_3de1e0d6' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_cacheheadersmiddlewarea4ee55c2_293d2d58 from 'nuxt_plugin_cacheheadersmiddlewarea4ee55c2_293d2d58' // Source: ./cache-headers.middleware.a4ee55c2.js (mode: 'all')
import nuxt_plugin_vuelightbox_36530636 from 'nuxt_plugin_vuelightbox_36530636' // Source: ../plugins/vue-lightbox.js (mode: 'client')
import nuxt_plugin_vuetoastification_3ddf5085 from 'nuxt_plugin_vuetoastification_3ddf5085' // Source: ../plugins/vue-toastification.js (mode: 'client')
import nuxt_plugin_persistedStateclient_3b127e9c from 'nuxt_plugin_persistedStateclient_3b127e9c' // Source: ../plugins/persistedState.client.js (mode: 'client')
import nuxt_plugin_composition_e1c96f18 from 'nuxt_plugin_composition_e1c96f18' // Source: ../plugins/composition (mode: 'all')
import nuxt_plugin_vueplyr_9db9a11c from 'nuxt_plugin_vueplyr_9db9a11c' // Source: ../plugins/vue-plyr (mode: 'all')
import nuxt_plugin_veevalidate_246dad14 from 'nuxt_plugin_veevalidate_246dad14' // Source: ../plugins/veevalidate (mode: 'all')
import nuxt_plugin_graphclient_84b05b52 from 'nuxt_plugin_graphclient_84b05b52' // Source: ../plugins/graph-client.js (mode: 'all')
import nuxt_plugin_locale_28023ea7 from 'nuxt_plugin_locale_28023ea7' // Source: ../plugins/locale.js (mode: 'all')
import nuxt_plugin_lodash_5d4c7b8c from 'nuxt_plugin_lodash_5d4c7b8c' // Source: ../plugins/lodash.js (mode: 'all')
import nuxt_plugin_redirHash_ccd67476 from 'nuxt_plugin_redirHash_ccd67476' // Source: ../plugins/redirHash.js (mode: 'all')
import nuxt_plugin_dayjs_66ce5f68 from 'nuxt_plugin_dayjs_66ce5f68' // Source: ../plugins/dayjs.js (mode: 'all')
import nuxt_plugin_errors_f8fa1014 from 'nuxt_plugin_errors_f8fa1014' // Source: ../plugins/errors.js (mode: 'all')
import nuxt_plugin_components_6fb0430c from 'nuxt_plugin_components_6fb0430c' // Source: ../plugins/components (mode: 'all')
import nuxt_plugin_structureddata_e024f720 from 'nuxt_plugin_structureddata_e024f720' // Source: ../plugins/structured-data (mode: 'all')
import nuxt_plugin_gtag_0a2cb1e4 from 'nuxt_plugin_gtag_0a2cb1e4' // Source: ../plugins/gtag.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"wintersport.nl","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"fb_app_id","property":"fb:app_id","content":"120994591283453"},{"hid":"msapplication-TileColor","name":"msapplication-TileColor","content":"#ffffff"},{"hid":"theme-color","name":"theme-color","content":"#ffffff"},{"hid":"apple-mobile-web-app-capable","name":"apple-mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-status-bar-style","name":"apple-mobile-web-app-status-bar-style","content":"black"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"hid":"favicon-32x32","rel":"icon","type":"image\u002Fpng","href":"\u002Fimages\u002Ffavicon-32x32.png","sizes":"32x32"},{"hid":"favicon-16x16","rel":"icon","type":"image\u002Fpng","href":"\u002Fimages\u002Ffavicon-16x16.png","sizes":"16x16"},{"hid":"mask-icon","rel":"mask-icon","href":"\u002Fimages\u002Fsafari-pinned-tab.svg","color":"#ff0000"},{"hid":"apple-touch-icon","rel":"apple-touch-icon","href":"\u002Fimages\u002Fapple-touch-icon.png","sizes":"180x180"},{"hid":"dns-prefetch-cdn","rel":"dns-prefetch","href":"https:\u002F\u002Fcdn.wintersport.nl"},{"hid":"dns-prefetch-static","rel":"dns-prefetch","href":"https:\u002F\u002Fstatic.wintersport.nl"},{"hid":"dns-prefetch-assets","rel":"dns-prefetch","href":"https:\u002F\u002Fassets.wintersport.nl"},{"hid":"preconnect-cdn","rel":"preconnect","href":"https:\u002F\u002Fcdn.wintersport.nl"},{"hid":"preconnect-static","rel":"preconnect","href":"https:\u002F\u002Fstatic.wintersport.nl"},{"hid":"preconnect-assets","rel":"preconnect","href":"https:\u002F\u002Fassets.wintersport.nl"},{"hid":"assets-ws-icons","href":"https:\u002F\u002Fassets.wintersport.nl\u002F_nuxt\u002Ffonts\u002Fws-icons.woff","rel":"preload","as":"font","type":"font\u002Fwoff","crossorigin":true},{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Material+Icons&display=swap"}],"style":[],"script":[{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Material+Icons&display=swap\";document.querySelector(\"head\").appendChild(l);})();"}],"noscript":[{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Material+Icons&display=swap\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_d134e8ca === 'function') {
    await nuxt_plugin_plugin_d134e8ca(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtenv_1f52afec === 'function') {
    await nuxt_plugin_nuxtenv_1f52afec(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_5165652a === 'function') {
    await nuxt_plugin_portalvue_5165652a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_1e5b0d5d === 'function') {
    await nuxt_plugin_pluginrouting_1e5b0d5d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_5a472332 === 'function') {
    await nuxt_plugin_pluginmain_5a472332(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_0228353c === 'function') {
    await nuxt_plugin_veevalidate_0228353c(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_3de1e0d6 === 'function') {
    await nuxt_plugin_apollomodule_3de1e0d6(app.context, inject)
  }

  if (typeof nuxt_plugin_cacheheadersmiddlewarea4ee55c2_293d2d58 === 'function') {
    await nuxt_plugin_cacheheadersmiddlewarea4ee55c2_293d2d58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelightbox_36530636 === 'function') {
    await nuxt_plugin_vuelightbox_36530636(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetoastification_3ddf5085 === 'function') {
    await nuxt_plugin_vuetoastification_3ddf5085(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistedStateclient_3b127e9c === 'function') {
    await nuxt_plugin_persistedStateclient_3b127e9c(app.context, inject)
  }

  if (typeof nuxt_plugin_composition_e1c96f18 === 'function') {
    await nuxt_plugin_composition_e1c96f18(app.context, inject)
  }

  if (typeof nuxt_plugin_vueplyr_9db9a11c === 'function') {
    await nuxt_plugin_vueplyr_9db9a11c(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_246dad14 === 'function') {
    await nuxt_plugin_veevalidate_246dad14(app.context, inject)
  }

  if (typeof nuxt_plugin_graphclient_84b05b52 === 'function') {
    await nuxt_plugin_graphclient_84b05b52(app.context, inject)
  }

  if (typeof nuxt_plugin_locale_28023ea7 === 'function') {
    await nuxt_plugin_locale_28023ea7(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_5d4c7b8c === 'function') {
    await nuxt_plugin_lodash_5d4c7b8c(app.context, inject)
  }

  if (typeof nuxt_plugin_redirHash_ccd67476 === 'function') {
    await nuxt_plugin_redirHash_ccd67476(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjs_66ce5f68 === 'function') {
    await nuxt_plugin_dayjs_66ce5f68(app.context, inject)
  }

  if (typeof nuxt_plugin_errors_f8fa1014 === 'function') {
    await nuxt_plugin_errors_f8fa1014(app.context, inject)
  }

  if (typeof nuxt_plugin_components_6fb0430c === 'function') {
    await nuxt_plugin_components_6fb0430c(app.context, inject)
  }

  if (typeof nuxt_plugin_structureddata_e024f720 === 'function') {
    await nuxt_plugin_structureddata_e024f720(app.context, inject)
  }

  if (typeof nuxt_plugin_gtag_0a2cb1e4 === 'function') {
    await nuxt_plugin_gtag_0a2cb1e4(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
